module.exports = __webpack_public_path__ + "img/logo_ITI-300x150.7fe6bc66.png";